<template>
  <div v-if="visitSource == 2" class="kw_tab" :style="'display:inline-block;'+tabBoxStyle" :class="'tab-'+type">
    <!-- type == 'no-line' -->
    <div v-if="(type)" :class="('i-class-'+type)+' '+('i-tabs-tab-'+type)+' '+( scroll ? 'i-tabs-tab-scroll-'+type : '' )+' '+( current ? 'i-tabs-tab-current-'+type : ' ' +  definehover )" :style="'background:'+(bgColor)">
        <el-badge :value="count" :class="'i-tabs-tab-badge-'+type">
            <div v-if="(type == 'iconBlock')" @click="handleClickItem">
              <div :style=" current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-'+type : ' ' +  definehover )" v-if="( current && currentColor )" ><img v-if="(bgFile!='')" :src="bgFile" class="iconBgFile"/>{{ title }}</div>
              <div :style=" current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-'+type : ' '  + definehover )" v-else><img v-if="(bgFile!='')" :src="(bgFile)" class="iconBgFile"/>{{ title }}</div>
            </div>
            <div v-else @click="handleClickItem">
              <img v-if="bgFile" :src="bgFile"/>
              <div :style=" current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-pc-'+type : ' ' +  definehover )" v-if="( current && currentColor )" >{{ title }}</div>
              <div :style=" current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-pc-'+type : ' ' +  definehover )" v-else>{{ title }}</div>
            </div>
        </el-badge>
        <div :class="('i-tabs-tab-bar-'+type)" v-if="current" :style="'background:'+( currentColor )"></div>
    </div>

    <div v-else :class="'i-class i-tabs-tab '+( scroll ? 'i-tabs-tab-scroll' : '' )+' '+( current ? 'i-tabs-tab-current' : ' ' +  definehover )">
        <el-badge :value="count" >
          <!-- 参数： fileType 为1时  tab为带有背景图片的文本块 -->
            <div v-if="(fileType == 1)" @click="handleClickItem" style="padding:0 5px">
                <div :class="'i-tabs-tab-title-fileType '+( current ? 'i-tabs-tab-title-current-pc-fileType' : ' ' +  definehover )" v-if="( current && currentColor )" :style="'background:url('+(bgFile)+') no-repeat;background-size: 100% 100%;'+ (current ? tabCheckStyle : tabDefaultStyle)"><span class="FileTypeText">{{ title }}</span></div>
                <div :class="'i-tabs-tab-title-fileType '+( current ? 'i-tabs-tab-title-current-pc-fileType' : ' ' +  definehover )" :style="'background:url('+(bgFile)+') no-repeat;background-size: 100% 100%;'+ (current ? tabCheckStyle : tabDefaultStyle)" v-else><span class="FileTypeText">{{ title }}</span></div>
            </div>

            <div v-else @click="handleClickItem" :style="bgFile?'min-width: 60px':''">
              <img v-if="bgFile" :src="bgFile" :class="bgFile?'topImg':''" />
                <div :class="'i-tabs-tab-title '+( current ? 'i-tabs-tab-title-current' : ' ' +  definehover )" v-if="( current && currentColor )" :style="current ? tabCheckStyle : tabDefaultStyle">{{ title }}</div>
                <div :style="current ? tabCheckStyle : tabDefaultStyle" :class="'i-tabs-tab-title '+( current ? 'i-tabs-tab-title-current' : ' ' +  definehover )" v-else>{{ title }}</div>
            </div>
        </el-badge>
        <div class="i-tabs-tab-bar" v-if="( current )" :style="'background: '+( currentColor )"></div>
    </div>
  </div>



    <div v-else class="kw_tab" :style="'display:inline-block;'+tabBoxStyle" :class="'tab-'+type">
        <!-- type == 'no-line' -->
        <div v-if="(type)" :class="('i-class-'+type)+' '+('i-tabs-tab-'+type)+' '+( scroll ? 'i-tabs-tab-scroll-'+type : '' )+' '+( current ? 'i-tabs-tab-current-'+type : '' )" :style="'background:'+(bgColor)">
            <el-badge :value="count" :class="'i-tabs-tab-badge-'+type">
                <div v-if="(type == 'iconBlock')" @click="handleClickItem">
                  <div :style="current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-'+type : '' )" v-if="( current && currentColor )" ><img v-if="(bgFile!='')" :src="bgFile" class="iconBgFile"/>{{ title }}</div>
                  <div :style="current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-'+type : '' )" v-else><img v-if="(bgFile!='')" :src="(bgFile)" class="iconBgFile"/>{{ title }}</div>
                </div>
                <div v-else @click="handleClickItem">
                    <img v-if="bgFile" :src="bgFile"/>
                    <div :style="current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-'+type : '' )" v-if="( current && currentColor )" >{{ title }}</div>
                    <div :style="current ? tabCheckStyle : tabDefaultStyle" :class="('i-tabs-tab-title-'+type)+' '+( current ? 'i-tabs-tab-title-current-'+type : '' )" v-else>{{ title }}</div>
                </div>
            </el-badge>
            <div :class="('i-tabs-tab-bar-'+type)" v-if="current" :style="'background:'+( currentColor )"></div>
        </div>

        <div v-else :class="'i-class i-tabs-tab '+( scroll ? 'i-tabs-tab-scroll' : '' )+' '+( current ? 'i-tabs-tab-current' : '' )">
            <el-badge :value="count" >
                <!-- 参数： fileType 为1时  tab为带有背景图片的文本块 -->
                <div v-if="(fileType == 1)" @click="handleClickItem" style="padding:0 5px">
                    <div :class="'i-tabs-tab-title-fileType '+( current ? 'i-tabs-tab-title-current-fileType' : '' )" v-if="( current && currentColor )" :style="'background:url('+(bgFile)+') no-repeat;background-size: 100% 100%;'+ (current ? tabCheckStyle : tabDefaultStyle)"><span class="FileTypeText">{{ title }}</span></div>
                    <div :class="'i-tabs-tab-title-fileType '+( current ? 'i-tabs-tab-title-current-fileType' : '' )" :style="'background:url('+(bgFile)+') no-repeat;background-size: 100% 100%;'+ (current ? tabCheckStyle : tabDefaultStyle)" v-else><span class="FileTypeText">{{ title }}</span></div>
                </div>

                <div v-else @click="handleClickItem" :style="bgFile?'min-width: 60px':''">
                    <img v-if="bgFile" :src="bgFile" :class="bgFile?'topImg':''" />
                    <div :class="'i-tabs-tab-title '+( current ? 'i-tabs-tab-title-current' : '' )" v-if="( current && currentColor )" :style="current ? tabCheckStyle : tabDefaultStyle">{{ title }}</div>
                    <div :style="current ? tabCheckStyle : tabDefaultStyle" :class="'i-tabs-tab-title '+( current ? 'i-tabs-tab-title-current' : '' )" v-else>{{ title }}</div>
                </div>
            </el-badge>
            <div class="i-tabs-tab-bar" v-if="( current )" :style="'background: '+( currentColor )"></div>
        </div>
    </div>
</template>

<script>
    import pageUtils from '@/js/page/pageUtil.js';
    import utils from '@/js/utils/util.js';
export default {
  name: 'kw_tab',
  props: {
    name:{
      
    },
    title: {
        type: String,
        default: ''
    },
    index:{
      default: ''
    },
    oneIndex:{
      default: ''
    },
    dot: {
        type: Boolean,
        value: false
    },
    count: {
        type: Number,
        value: 0
    },
    //图片路径
    bgFile: {
      type: String,
      value: ''
    },
    //图片位置 1:背景图片  2:上部图片
    imgPosition:{
      type: Number, 
      value:0
    },
    type: {
      type: String,
      value: ''
    },
    size: {
      type: String,
      value: ''
    },
    fontSize: {
      type: String,
      value: 14
    },
    fileType: {
      type: String,
      value: 0
    },
    color: {
      type: String,
      value: '#000'
    },
    //      tab选中字体颜色
    fontCheckColor: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      value: ''
    },
    bgCheckColor: {
      type: String,
      value: ''
    },
    margin: {
      type: String,
      value: ''
    },
    tabCheckPadding: {
      type: String,
      value: ''
    },
    // 默认未选中padding
    tabDefaultPadding:{
      type: String,
      value: ''
    },
    tabWidth: {
      type: String,
      value: ''
    },
    // 宽高
    tabWidth: {
      type: String,
      value: ''
    },
    tabHeight: {
      type: String,
      value: ''
    },
    tabRadius: {
      type: String,
      value: ''
    },
    //tab外层的样式
    tabBoxStyle:{
      type: String,
      value: ''
    },
    //未选中的样式
    tabDefaultStyle: {
      type: String,
      value: ''
    },
    //选中的样式
    tabCheckStyle: {
       type: String,
       value: ''
    },
    // 鼠标hover样式
    definehover: {
      type: String,
      value: ''
    }
  },
  data() {
    return {
        // 访问来源 PC:2 或者 H5:3
        visitSource:utils.checkVisitSource(),
    };
  },
  created() {
  },
  mounted() {
  },
  watch:{
  },
  computed:{
    current() {
      var active = false;
      if (("," + this.$parent.myValue + ",").indexOf("," + this.name + ",") >= 0) {
        active = true;
      }
      return active;
    },
    currentColor(){
      console.log("parentCurrentColor============" + this.$parent.currentColor);
      return this.$parent.currentColor;
    },
    scroll(){
      return this.$parent.scroll;
    }
  },
  components: {
    
  },
  methods: {
    handleClickItem () {
//      console.log("kw_tab=================点击",this);
      this.$parent.emitEvent(this);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topImg{width: 32px;height: 32px;margin-top: 11px}
.i-tabs-tab{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title{font-size:14px;text-align:center;box-sizing:border-box;color:#1e1e1e}.i-tabs-tab-title-current{color:#2d8cf0}
.i-tabs-tab-scroll{display:inline-block;width:60px}
.i-tabs.SearchScroll{background: none;}
.i-tabs-tab-bar{display: none;}
.i-tabs-tab-scroll{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title{padding: .3rem 1rem;}
.i-tabs-tab-title-current{border-radius: 0.2rem; padding: .3rem 1rem; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #409eff;}
.i-tabs-tab-bar{display: none;}

/* //////////////////no-line///////////////////////// */

.i-tabs-tab-no-line{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-no-line{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-no-line{font-size:16px;text-align:center;box-sizing:border-box;color:#6F6F6F;font-weight: bold}
.i-tabs-tab-title-current-no-line{color:#2d8cf0}
.i-tabs-tab-title-current-pc-no-line{color:#2d8cf0}
.i-tabs-tab-scroll-no-line{display:inline-block;width:60px}
.i-tabs.SearchScroll-no-line{background: none;}
.i-tabs-tab-bar-no-line{display: none;}
.i-tabs-tab-scroll-no-line{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-no-line{padding: .3rem 2rem;}
.i-tabs-tab-title-current-no-line{border-radius: 6rem; padding: .3rem 2rem; overflow: hidden; color: #FF4849; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #ffffff;}
.i-tabs-tab-title-current-pc-no-line{border-radius: 6rem; padding: .3rem 2rem; overflow: hidden; color: #FF4849; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #ffffff;}
.i-tabs-tab-bar-no-line{display: none;}

/* //////////////////block///////////////////////// */

.i-tabs-tab-block{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-block{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-block{font-size:14px;text-align:center;box-sizing:border-box;color:#80848f}
.i-tabs-tab-title-current-block{color:#2d8cf0}
.i-tabs-tab-title-current-pc-block{color:#2d8cf0}
.i-tabs-tab-scroll-block{display:inline-block;width:60px}
.i-tabs.SearchScroll-block{background: none;}
.i-tabs-tab-bar-block{display: none;}
.i-tabs-tab-scroll-block{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-block{padding: .3rem 1rem;}
.i-tabs-tab-title-current-block{padding: .2rem .8rem; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FF5858;}
.i-tabs-tab-title-current-pc-block{padding: .2rem .8rem; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FF5858;}
.i-tabs-tab-bar-block{display: none;}

/* //////////////////iconBlock///////////////////////// */


.i-tabs-tab-iconBlock{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-iconBlock{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#eee}
.i-tabs-tab-title-iconBlock{font-size:14px;text-align:center;box-sizing:border-box;color:#5a5a5a;background: #eee;margin: 0 5px;padding: 10px 0}
.i-tabs-tab-title-current-iconBlock{color:#5a5a5a}
.i-tabs-tab-scroll-iconBlock{display:inline-block;width:60px}
.i-tabs.SearchScroll-iconBlock{background: none;}
.i-tabs-tab-bar-iconBlock{display: none;}
.i-tabs-tab-scroll-iconBlock{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-current-iconBlock{margin: 0 5px;padding: 10px 0; overflow: hidden; color: #5a5a5a; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #eee;}
.i-tabs-tab-bar-iconBlock{display: none;}

/* //////////////////intervalTab///////////////////////// */

.i-tabs-tab-intervalTab{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-intervalTab{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-intervalTab{font-size:14px;text-align:center;box-sizing:border-box;color:#171717;background: #F6F6F6;border-top-left-radius: 5px;border-top-right-radius: 5px;}
.i-tabs-tab-title-current-intervalTab{color:#2d8cf0}
.i-tabs-tab-title-current-pc-intervalTab{color:#2d8cf0}
.i-tabs-tab-scroll-intervalTab{display:inline-block;width:60px}
.i-tabs.SearchScroll-intervalTab{background: none;}
.i-tabs-tab-bar-intervalTab{display: none;}
.i-tabs-tab-scroll-intervalTab{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-intervalTab{padding: 7px 9px;}
.i-tabs-tab-title-current-intervalTab{padding: 7px 9px; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FF5858;}
.i-tabs-tab-title-current-pc-intervalTab{padding: 7px 9px; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FF5858;}
.i-tabs-tab-bar-intervalTab{display: none;}

/* //////////////////tabPage///////////////////////// */

.tab-tabPage{width: 33.33%}
.i-tabs-tab-badge-tabPage{width: 100%}
.i-tabs-tab-tabPage{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative;background:#92C5FE;border-radius: 10px 10px 0 0}
.i-tabs-tab-bar-tabPage{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
/*.i-tabs-tab-title-tabPage{font-size:14px;text-align:center;box-sizing:border-box;word-wrap: break-word;word-break: break-all;white-space: pre-line;width: 119px;height: 50px;color:#489FFF;border: 5px solid transparent;display: flex;align-items: center;border-right: 1px solid transparent;border-left: 1px solid transparent;border-radius: 10px 10px 0 0;}*/
.i-tabs-tab-title-tabPage{padding: .3rem 1rem;font-size:14px;text-align:center;box-sizing:border-box;word-wrap: break-word;word-break: break-all;white-space: pre-line;width: 100%;height: 50px;color:#489FFF;border: 5px solid transparent;display: flex;align-items: center;border-right: 1px solid transparent;border-left: 1px solid transparent;border-radius: 10px 10px 0 0;justify-content: center}
/*.i-tabs-tab-title-current-tabPage{color:#2d8cf0;height: 50px;width: 119px;}*/
.i-tabs-tab-title-current-tabPage{color:#2d8cf0;height: 50px;width: 100%;}
.i-tabs-tab-title-current-pc-tabPage{color:#2d8cf0;height: 50px;width: 100%;}
.i-tabs.SearchScroll-tabPage{background: none;}
.i-tabs-tab-bar-tabPage{display: none;}
.i-tabs-tab-scroll-tabPage{display: inline-block;line-height: 1rem;}
.i-tabs-tab-title-current-tabPage{padding: .2rem .8rem; overflow: hidden; color: #373268; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #fff;border:5px solid #FEDED2;border-bottom:none;border-radius: 10px 10px 0 0;border-right: 1px solid #E6E6E7;border-left: 1px solid #E6E6E7}
.i-tabs-tab-title-current-pc-tabPage{padding: .2rem .8rem; overflow: hidden; color: #373268; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #fff;border:5px solid #FEDED2;border-bottom:none;border-radius: 10px 10px 0 0;border-right: 1px solid #E6E6E7;border-left: 1px solid #E6E6E7}
.i-tabs-tab-bar-tabPage{display: none;}

/* //////////////////menu///////////////////////// */

.i-tabs-tab-menu{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-menu{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-menu{box-sizing:border-box;font-size: 14px;color: #656565;border: 1px solid #EFEFEF;text-align: center;width: 100px;height: 32px;line-height: 32px;border-radius: 32px;margin: 5px 10px}
.i-tabs-tab-title-current-menu{color:#2d8cf0}
.i-tabs-tab-title-current-pc-menu{color:#2d8cf0}
.i-tabs-tab-scroll-menu{display:inline-block;width:60px}
.i-tabs.SearchScroll-menu{background: none;}
.i-tabs-tab-bar-menu{display: none;}
.i-tabs-tab-scroll-menu{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-current-menu{border-radius: 32px; width: 100px;height: 32px;line-height: 32px;background: #FF4849;color: #fff;border: 1px solid #FF4849;}
.i-tabs-tab-title-current-pc-menu{border-radius: 32px; width: 100px;height: 32px;line-height: 32px;background: #FF4849;color: #fff;border: 1px solid #FF4849;}
.i-tabs-tab-bar-menu{display: none;}

/* //////////////////line///////////////////////// */

.i-tabs-tab-line{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-line{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-line{font-size:16px;text-align:center;box-sizing:border-box;color:#6F6F6F;font-weight: bold}
.i-tabs-tab-title-current-line{color:#2d8cf0}
.i-tabs-tab-title-current-pc-line{color:#2d8cf0}
.i-tabs-tab-scroll-line{display:inline-block;width:60px}
.i-tabs.SearchScroll-line{background: none;}
.i-tabs-tab-bar-line{display: none;}
.i-tabs-tab-scroll-line{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-line{margin: 0 1.5rem}
.i-tabs-tab-title-current-line{padding-bottom: 1.9px;border-bottom:2px solid #FE2B10; overflow: hidden; color: #FF4849; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #ffffff;}
.i-tabs-tab-title-current-pc-line{padding-bottom: 1.9px;border-bottom:2px solid #FE2B10; overflow: hidden; color: #FF4849; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #ffffff;}
.i-tabs-tab-bar-line{display: none;}

/* //////////////////fillet///////////////////////// */

.i-tabs-tab-fillet{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-fillet{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0;}
.i-tabs-tab-title-fillet{font-size:14px;text-align:center;box-sizing:border-box;color:#80848f;background: transparent;width: 100%;padding: .5rem 0}
.i-tabs-tab-title-current-fillet{color:#509beb}
.i-tabs-tab-title-current-pc-fillet{color:#509beb}
.i-tabs-tab-badge-fillet{width: 100%}
.i-tabs.SearchScroll-fillet{background: none;}
.i-tabs-tab-bar-fillet{display: none;}
.i-tabs-tab-scroll-fillet{display: inline-block; width: 100%; line-height: 1rem;}
.i-tabs-tab-title-current-fillet{border-radius: 6rem; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FBAC47;}
.i-tabs-tab-title-current-pc-fillet{border-radius: 6rem; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FBAC47;}
.i-tabs-tab-bar-fillet{display: none;}
.tab-fillet{width: 50%}

/* //////////////////paihang///////////////////////// */

.i-tabs-tab-paihang{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-paihang{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-paihang{font-size:16px;text-align:center;box-sizing:border-box;color:#fff;font-weight: bold}
.i-tabs-tab-title-current-paihang{color:#F9BC2E}
.i-tabs-tab-title-current-pc-paihang{color:#F9BC2E}
.i-tabs-tab-scroll-paihang{display:inline-block;width:60px}
.i-tabs.SearchScroll-paihang{background: none;}
.i-tabs-tab-bar-paihang{display: none;}
.i-tabs-tab-scroll-paihang{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-paihang{padding: .3rem 2rem;}
.i-tabs-tab-title-current-paihang{border-radius: 6rem; padding: .3rem 2rem; overflow: hidden; color:#F9BC2E; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: transparent;}
.i-tabs-tab-title-current-pc-paihang{border-radius: 6rem; padding: .3rem 2rem; overflow: hidden; color:#F9BC2E; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: transparent;}
.i-tabs-tab-bar-paihang{display: none;}
.i-tabs-tab-title-current-paihang:after {position: absolute;left: 50%;bottom: 0;content: '';width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-bottom: 5px solid #fff;transform: translate(-50%)}
.i-tabs-tab-title-current-pc-paihang:after {position: absolute;left: 50%;bottom: -10px;content: '';width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-bottom: 5px solid #fff;transform: translate(-50%)}

/* //////////////////参数： fileType 为1时  tab为带有背景图片的文本块css///////////////////////// */

.i-tabs-tab-title-fileType{font-size:14px;box-sizing:border-box;height: 58px;width: 161px;line-height: 58px;color:#fff;border-radius: 5px;margin-top: 5px;text-align: left}
.i-tabs-tab-title-current-fileType{font-size:14px;box-sizing:border-box;height: 58px;width: 161px;line-height: 58px;color:#fff;border-radius: 5px;margin-top: 9px;text-align: left}
.i-tabs-tab-title-current-pc-fileType{font-size:14px;box-sizing:border-box;height: 58px;width: 161px;line-height: 58px;color:#fff;border-radius: 5px;margin-top: 9px;text-align: left}
.FileTypeText{padding-left: 20px;}

/* //////////////////live///////////////////////// */

.i-tabs-tab-live{flex:1;display:flex;width:100%;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;position:relative}
.i-tabs-tab-bar-live{display:block;width:100%;height:2px;background:0 0;position:absolute;bottom:0;left:0;background:#2d8cf0}
.i-tabs-tab-title-live{font-size:14px;text-align:center;box-sizing:border-box;color:#1e1e1e}
.i-tabs-tab-title-current-live{color:#2d8cf0}
.i-tabs-tab-title-current-pc-live{color:#2d8cf0}
.i-tabs-tab-scroll-live{display:inline-block;width:60px}
.i-tabs.SearchScroll-live{background: none;}
.i-tabs-tab-bar-live{display: none;}
.i-tabs-tab-scroll-live{display: inline-block; width: auto; line-height: 1rem;}
.i-tabs-tab-title-live{padding: 2.5px 10px;}
.i-tabs-tab-title-current-live{padding: 2.5px 10px; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FF5858;border-radius: 5px;}
.i-tabs-tab-title-current-pc-live{padding: 2.5px 10px; overflow: hidden; color: #fff; background-repeat: no-repeat; background-size: 100% 100%;-moz-background-size: 100% 100%;background-color: #FF5858;border-radius: 5px;}
.i-tabs-tab-bar-live{display: none;}

/* i-tabs-tab-title和i-tabs-tab-title-current大小控制 */
.iconBgFile{width: 20px;height: 20px;vertical-align: sub;margin-right: 3px}

.default{padding: .2rem .8rem;}
.small{padding: .2rem .3rem}
.max{padding: .3rem 2rem;}
.Equipartition4{padding: 10px 0}
</style>
